import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';

export function handleOpenHomeDeepLink(
  incomingUrl?: string | null,
  changeRoot: (route: AppRoutes, initialTabRoute?: AppRoutes) => void = () =>
    undefined,
) {
  if (!incomingUrl) {
    return false;
  }
  const lower = incomingUrl.toLowerCase();
  const isOpenPath = lower.includes('://open');
  const hasHomeDest = lower.includes('destination=home');

  try {
    FirebaseAnalytic.trackEvent('DeepLinkHandle', 'App', {
      incomingUrl,
      isOpenPath,
      hasHomeDest,
      currentRoute: NavActions.getLastRoute?.(),
    });
  } catch {}

  if (isOpenPath && hasHomeDest) {
    changeRoot(AppRoutes.App, AppRoutes.HomeTab);
    NavActions.reset(AppRoutes.Main);

    setTimeout(() => {
      NavActions.navigate(AppRoutes.Main);
    }, 100);

    try {
      FirebaseAnalytic.trackEvent('DeepLinkNavigateHome', 'App', {
        afterRoute: NavActions.getLastRoute?.(),
        source: 'Android Activity Tracker',
        url: incomingUrl,
        forcedToMain: true,
      });
    } catch {}
    return true;
  }
  return false;
}
